import { render, staticRenderFns } from "./_gender.vue?vue&type=template&id=7bc5201a"
import script from "./_gender.vue?vue&type=script&lang=js"
export * from "./_gender.vue?vue&type=script&lang=js"
import style0 from "./_gender.vue?vue&type=style&index=0&id=7bc5201a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Breadcrumbs: require('/app/components/global/breadcrumbs.vue').default,VSelect: require('/app/node_modules/vuetify/lib/components/VSelect/VSelect.js').default,Categories: require('/app/components/categories/categories.vue').default})


/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
